window.Instant = window.Instant || {};
window.Instant.initializedVersion = window.Instant?.initializedVersion || null;
window.Instant.initializedListeners = !!window.Instant?.initializedListeners;
window.Instant.initializedSwiper = !!window.Instant?.initializedSwiper;
window.Instant.initSwiper =
  window.Instant?.initSwiper ||
  (() => {
    window.Instant.initializedSwiper ||
      ((window.Instant.initializedSwiper = !0),
      window.Instant.initializedListeners && window.__instantInitSliders?.());
  });
(() => {
  let lt = new RegExp("^i[a-zA-Z0-9]{16}$"),
    G = (n) => lt.test(n),
    ct = (n) => (G(n) ? n.substring(1, 16 + 1) : n),
    T = (n) => {
      let e = Array.from(n.classList);
      return e.find((t) => G(t)) ?? e[0];
    },
    x = (n) => n?.replace(/gid:\/\/shopify\/.*\//im, ""),
    J = (n) => {
      let e = n.parentElement;
      return e instanceof HTMLSpanElement ? J(e) : e;
    },
    $ = (n) => {
      let e = n.getAttribute("data-instant-repeater-index");
      return `${ct(T(n))}${e != null ? `_${e}` : ""}`;
    },
    K = (n, e) => n?.replace(/:(-?\d+)/, `:${e}`),
    dt = ({
      dataset: n,
      variantId: e,
      scope: t,
      scopeId: i,
      priceElements: s,
      comparativePriceElements: r,
      variantSelectOptions: l,
      variantRadios: o,
      featuredVariantImages: d,
      repeaterImages: g,
      addToCartButtons: m,
      viewProductButtons: E,
      quantity: h,
      customVariantSelects: w,
      sellingPlanElements: y,
      selectedSellingPlan: b,
      conditionals: M,
    }) => {
      if (!e) {
        for (let p of s)
          p?.closest("[data-instant-form-product-url]") === t &&
            p &&
            (p.innerHTML = "&nbsp;");
        for (let p of r)
          p?.closest("[data-instant-form-product-url]") === t &&
            p &&
            (p.innerHTML = "&nbsp;");
        for (let p of m)
          p.closest("[data-instant-form-product-url]") === t &&
            p &&
            p.setAttribute("data-instant-disabled", "true");
        for (let p of l)
          if (p?.closest("[data-instant-form-product-url]") === t && p) {
            let I = p
                ?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')
                ?.querySelector(
                  'span[data-instant-type="selected-variant-option"]'
                ),
              P = p.closest("select");
            p.value === P?.value
              ? (p.setAttribute("selected", ""),
                I && (I.innerHTML = p.innerHTML))
              : p.removeAttribute("selected");
          }
        return;
      }
      if (
        t.closest('[data-instant-layout="PRODUCT_TEMPLATE"]') &&
        t.getAttribute("data-instant-type") === "root"
      ) {
        let p = new URL(window.location.toString());
        p.searchParams.set("variant", e),
          window.history.replaceState({}, "", p.toString());
      }
      let v = new URLSearchParams({ variant: e, section_id: n.sectionId });
      b?.sellingPlanId && v.set("selling_plan", b.sellingPlanId),
        fetch(`${n.url}?${v.toString()}`)
          .then((p) => p.text())
          .then((p) => {
            let I = new DOMParser().parseFromString(p, "text/html"),
              P = t.getAttribute("data-instant-form-product-url"),
              [k, _] = i.split("_"),
              A = I.querySelector(
                `.i${k}${
                  _ != null ? `[data-instant-repeater-index="${_}"]` : ""
                }[data-instant-form-product-url="${P}"]`
              );
            if (!A) {
              console.warn("Could not find source element in response");
              return;
            }
            let q = Array.from(
                A?.querySelectorAll(
                  '[data-instant-dynamic-content-source="PRICE"]'
                )
              ),
              rt = ["COMPARE_AT", "SAVED_AMOUNT", "SAVED_PERCENTAGE"]
                .map((a) => `[data-instant-dynamic-content-source="${a}"]`)
                .join(", "),
              V = Array.from(A.querySelectorAll(rt)),
              B = Array.from(
                A?.querySelectorAll(
                  'fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]'
                )
              ),
              D = Array.from(
                A?.querySelectorAll(
                  'fieldset[data-instant-type="VARIANT_PICKER"] select option'
                )
              ),
              F = Array.from(
                A?.querySelectorAll(
                  '[data-instant-action-type="select-variant-option"]'
                )
              ),
              z = ["add-to-cart", "redirect-to-cart", "redirect-to-checkout"]
                .map((a) => `[data-instant-action-type="${a}"]`)
                .join(", "),
              ot = Array.from(A?.querySelectorAll(z)),
              U = Array.from(
                A?.querySelectorAll('[data-instant-action-type="open-page"]')
              ),
              Q = Array.from(
                A?.querySelectorAll(
                  'img[data-instant-dynamic-content-source="FEATURED_IMAGE"]'
                )
              ),
              j = Array.from(
                A?.querySelectorAll(
                  'img[data-instant-dynamic-content-source="REPEATER"]'
                )
              ),
              W = Array.from(A?.querySelectorAll("[data-instant-conditional]")),
              C = document.querySelector(`input[name="${i}__selling-plan-id"]`),
              O = document.querySelector(
                `input[name="${i}__selling-plan-name"]`
              ),
              N = !1;
            for (let a of y) {
              let u = T(a),
                c = Array.from(
                  A?.querySelectorAll(
                    '[data-instant-action-type="select-selling-plan"]'
                  )
                ).find((S) => T(S) === u);
              if (c?.closest("[data-instant-form-product-url]") !== A) continue;
              let f = decodeURIComponent(
                  c.getAttribute("data-instant-selling-plan-name")
                ),
                L = c.getAttribute("data-instant-selling-plan-id");
              if (!b && L === "one-time-purchase") {
                a.setAttribute("data-instant-state", "active");
                continue;
              }
              if (b?.sellingPlanId === L || b?.sellingPlanName === f) {
                a.setAttribute("data-instant-state", "active"),
                  c.getAttribute("data-instant-disabled") === "true" &&
                    (N = !0);
                continue;
              }
              a.setAttribute("data-instant-state", "inactive");
            }
            for (let a of s) {
              let u = T(a),
                c = q.find((f) => T(f) === u);
              c?.closest("[data-instant-form-product-url]") === A &&
                c &&
                (N ? (a.innerHTML = "&nbsp;") : (a.innerHTML = c.innerHTML));
            }
            for (let a of r) {
              let u = T(a),
                c = V.find((f) => T(f) === u);
              if (c?.closest("[data-instant-form-product-url]") === A && c) {
                N ? (a.innerHTML = "&nbsp;") : (a.innerHTML = c.innerHTML);
                let f = c.getAttribute("style");
                f ? a.setAttribute("style", f) : a.removeAttribute("style");
              }
            }
            for (let a of o) {
              let u = B.find((c) => c.id === a.id);
              if (u?.closest("[data-instant-form-product-url]") === A && u) {
                let c = u.getAttribute("data-instant-disabled");
                c
                  ? a.setAttribute("data-instant-disabled", c)
                  : a.removeAttribute("data-instant-disabled"),
                  u.hasAttribute("checked")
                    ? (a.checked = !0)
                    : (a.checked = !1);
                let f;
                if ((a.labels && ([f] = Array.from(a.labels)), f)) {
                  let L;
                  if ((u.labels && ([L] = Array.from(u.labels)), L)) {
                    let S = L.getAttribute("title");
                    S && f.setAttribute("title", S);
                  }
                }
              }
            }
            for (let a of l) {
              let u = D.find((c) => c.id === a.id);
              if (u?.closest("[data-instant-form-product-url]") === A && u) {
                let c = u.getAttribute("data-instant-disabled");
                c
                  ? a.setAttribute("data-instant-disabled", c)
                  : a.removeAttribute("data-instant-disabled"),
                  (a.textContent = u.textContent);
                let f = a
                  ?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')
                  ?.querySelector(
                    'span[data-instant-type="selected-variant-option"]'
                  );
                u.hasAttribute("selected")
                  ? (a.setAttribute("selected", ""),
                    f && (f.innerHTML = u.innerHTML))
                  : a.removeAttribute("selected");
              }
            }
            for (let a of d) {
              let u = T(a),
                c = Q.find((f) => T(f) === u);
              c?.closest("[data-instant-form-product-url]") === A &&
                c &&
                ((a.src = c.src),
                (a.sizes = c.sizes),
                (a.srcset = c.srcset),
                (a.alt = c.alt),
                (a.height = c.height),
                (a.width = c.width));
            }
            for (let a of g) {
              let u = j.find(
                (c) =>
                  c.getAttribute("data-instant-repeater-id") ===
                    a.getAttribute("data-instant-repeater-id") &&
                  c.getAttribute("data-instant-repeater-index") ===
                    a.getAttribute("data-instant-repeater-index")
              );
              u?.closest("[data-instant-form-product-url]") === A &&
                u &&
                ((a.src = u.src),
                (a.sizes = u.sizes),
                (a.srcset = u.srcset),
                (a.alt = u.alt),
                (a.height = u.height),
                (a.width = u.width));
            }
            for (let a of m) {
              let u = T(a),
                c = ot.find((f) => T(f) === u);
              if (c?.closest("[data-instant-form-product-url]") === A && c) {
                c.getAttribute("data-instant-disabled") === "true"
                  ? a.setAttribute("data-instant-disabled", "true")
                  : a.removeAttribute("data-instant-disabled");
                for (let L of y)
                  L.getAttribute("data-instant-state") === "active" &&
                    L.getAttribute("data-instant-disabled") === "true" &&
                    a.setAttribute("data-instant-disabled", "true");
                a.setAttribute("data-instant-action-variant-id", e),
                  (a.href = K(c.href, String(h ?? 1)));
              }
            }
            for (let a of E) {
              let u = T(a),
                c = U.find((f) => T(f) === u);
              if (c?.closest("[data-instant-form-product-url]") === A && c) {
                let f = new URL(c.href);
                f.searchParams.set("variant", e), (a.href = f.toString());
              }
            }
            for (let a of w) {
              let u = T(a),
                c = F.find((f) => T(f) === u);
              c?.closest("[data-instant-form-product-url]") === A &&
                c &&
                (a.setAttribute(
                  "data-instant-state",
                  c.getAttribute("data-instant-state") ?? "inactive"
                ),
                a.setAttribute(
                  "data-instant-disabled",
                  c.getAttribute("data-instant-disabled") ?? ""
                ));
            }
            b ||
              (O && O.remove(),
              C && C.value !== "one-time-purchase" && C.remove());
            for (let a of M) {
              let u = T(a),
                c = W.find((L) => T(L) === u);
              if (c?.closest("[data-instant-form-product-url]") !== A) continue;
              let f = c.getAttribute("style");
              f ? a.setAttribute("style", f) : a.removeAttribute("style");
            }
          });
    };
  window.__instantInitSliders = (n = document) => {
    if (!window.Instant.initializedSwiper) {
      if (n.querySelector('[data-instant-type="slider"]')) {
        let r = document.createElement("script");
        (r.onload = window.Instant.initSwiper),
          (r.src =
            window.Instant.swiperScriptUrl ||
            "https://client.instant.so/scripts/swiper-bundle.min.js"),
          document.body.appendChild(r);
      }
      return;
    }
    let e = {},
      t = (r, l = "slider") => {
        if (r && r.id) {
          let o = document.getElementById(`instant-slider-${r.id}-params`),
            d = r.closest(".__instant")?.getAttribute("data-section-id"),
            g = r.getAttribute("data-instant-slider-id");
          try {
            if (o?.innerHTML) {
              let m = JSON.parse(o.innerHTML);
              if (
                (d &&
                  m.navigation &&
                  ((m.navigation.nextEl = `[data-section-id='${d}'] ${m.navigation.nextEl}`),
                  (m.navigation.prevEl = `[data-section-id='${d}'] ${m.navigation.prevEl}`)),
                m.pagination)
              ) {
                let E = document.querySelector(
                    `[data-section-id='${d}'] ${m.pagination.el}`
                  ),
                  h = E?.querySelector(".instant-slider-pagination-bullet");
                if (E && h) {
                  let w = T(h);
                  m.pagination.renderBullet = (y, b) =>
                    `<span class="${b} ${w}"></span>`;
                }
              }
              if (l === "thumbnails") {
                let E = new Swiper(r, m);
                e[`${g}`] = E;
              } else
                m.thumbs &&
                  e?.[`${g}`] &&
                  (m.thumbs = { swiper: e?.[`${g}`], ...m.thumbs }),
                  new Swiper(r, m);
            }
          } catch {}
        }
      },
      i = n.querySelectorAll('[data-instant-type="thumbnails"]');
    Array.from(i).forEach((r) => {
      t(r, "thumbnails");
    });
    let s = n.querySelectorAll('[data-instant-type="slider"]');
    Array.from(s).forEach((r) => {
      t(r);
    });
  };
  let ut = (n) => {
      let e = document.getElementById(`i${n}`);
      e && e.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    Y = (n, e = !1) => {
      n.forEach((t) => {
        let i = t.querySelector(
          ':scope > [data-instant-type="accordion-content"]'
        );
        if (i) {
          let s = i.style.transitionDuration;
          (i.style.transitionDuration = "0s"),
            i.style.setProperty(
              "--instant-accordion-content-height",
              "initial"
            ),
            i.style.setProperty("--instant-accordion-content-width", "initial");
          let { height: r, width: l } = i.getBoundingClientRect();
          (i.style.transitionDuration = s),
            i.style.setProperty("--instant-accordion-content-height", "0"),
            i.style.setProperty("--instant-accordion-content-width", "0");
          let o = () => {
            r &&
              i.style.setProperty(
                "--instant-accordion-content-height",
                `${r}px`
              ),
              l &&
                i.style.setProperty(
                  "--instant-accordion-content-width",
                  `${l}px`
                );
          };
          e
            ? o()
            : "requestAnimationFrame" in window
            ? window.requestAnimationFrame(o)
            : setTimeout(o, 16);
        }
      });
    },
    pt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="accordion-container"]');
      Array.from(e)
        .reverse()
        .forEach((t) => {
          let i = t.getAttribute("data-is-multi-open-enabled") === "true",
            s = t.querySelectorAll(
              ':scope > [data-instant-type="accordion-item"]'
            );
          Y(Array.from(s), !0),
            Array.from(s).forEach((r) => {
              let l = r.querySelector(
                ':scope > [data-instant-type="accordion-header"]'
              );
              l &&
                l.addEventListener("click", () => {
                  let o = r.getAttribute("data-state") === "open";
                  r.setAttribute("data-state", o ? "closed" : "open"),
                    o || Y([r]),
                    i ||
                      Array.from(s).forEach((d) => {
                        d !== r &&
                          d.getAttribute("data-state") === "open" &&
                          d.setAttribute("data-state", "closed");
                      });
                });
            });
        });
    },
    mt = (n) => {
      let e = n.querySelectorAll("[data-instant-product-recommendations]");
      Array.from(e).forEach((t) => {
        let i = t?.parentElement,
          s = t.getAttribute("data-instant-product-recommendations");
        if (i && s) {
          if (t.getAttribute("data-instant-observed")) return;
          t.setAttribute("data-instant-observed", "true");
          let r = (o, d) => {
            if (!o[0].isIntersecting) return;
            d.unobserve(i);
            let g = t.getAttribute("data-url");
            g &&
              fetch(g)
                .then((m) => m.text())
                .then((m) => {
                  let h = new DOMParser()
                    .parseFromString(m, "text/html")
                    .querySelector(
                      `[data-instant-product-recommendations-output="${s}"]`
                    );
                  h &&
                    h.innerHTML.trim().length &&
                    (t.insertAdjacentHTML("afterend", h.innerHTML),
                    i && R(i),
                    t.remove());
                })
                .catch((m) => {
                  console.error(m);
                });
          };
          new IntersectionObserver(r, {
            rootMargin: "0px 0px 200px 0px",
          }).observe(i);
        }
      });
    },
    ft = (n, e) => {
      let i = ((l) => {
        if (!l) return null;
        let o = l.closest("[data-instant-form-product-url]");
        if (!o) return null;
        let d = o.querySelector(
          '[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
        );
        if (d) return d;
      })(n);
      if (!i) return;
      let s = parseInt(i?.value, 10);
      isNaN(s) && (s = 1);
      let r = e === "increment" ? s + 1 : s - 1;
      r < 1 ||
        r > 999 ||
        ((i.value = r.toString()),
        i.dispatchEvent(new Event("change", { bubbles: !0 })));
    },
    gt = (n) => {
      let e = n.closest("[data-instant-form-product-url]");
      if (!e) return null;
      let t = $(e),
        i = `${t}__${n.getAttribute("data-instant-option-name")}`,
        s = n.getAttribute("data-instant-option-value") ?? "",
        r = e.querySelectorAll(`input[name^="${t}__"]`),
        l = [];
      for (let o of r) o.name === i && l.push(o);
      if (l?.length === 1) l[0].value = s;
      else if (l?.length > 1)
        l.forEach((o) => {
          o.checked = o.value === n.getAttribute("data-instant-option-value");
        });
      else {
        let o = document.createElement("input");
        e.appendChild(o),
          o.setAttribute("type", "hidden"),
          o.setAttribute("name", i),
          o.setAttribute("value", s);
      }
      e.dispatchEvent(new Event("change", { cancelable: !0, bubbles: !0 }));
    },
    yt = (n) => {
      let e = n.closest("[data-instant-form-product-url]");
      if (!e) return null;
      let t = $(e),
        i = (s, r) => {
          let l = n.getAttribute(r) ?? "",
            o = e.querySelector(`input[name="${s}"]`);
          if (o) o.value = l;
          else {
            let d = document.createElement("input");
            e.appendChild(d),
              d.setAttribute("type", "hidden"),
              d.setAttribute("name", s),
              d.setAttribute("value", l);
          }
        };
      i(`${t}__selling-plan-id`, "data-instant-selling-plan-id"),
        i(`${t}__selling-plan-name`, "data-instant-selling-plan-name"),
        e.dispatchEvent(new Event("change", { cancelable: !0, bubbles: !0 }));
    },
    Z = async (n) => {
      let e = n.getAttribute("data-instant-action-type"),
        t = n.getAttribute("data-instant-action-id"),
        i = n.getAttribute("data-instant-action-variant-id");
      if (
        n.getAttribute("data-instant-disabled") === "true" &&
        !["select-variant-option", "select-selling-plan"].includes(e)
      )
        return !0;
      switch (e) {
        case "add-to-cart":
        case "redirect-to-cart":
        case "redirect-to-checkout":
          let r = new URL(n.href).pathname.split(":").pop() ?? "1",
            l = n.getAttribute("data-instant-discount-code"),
            o = n.getAttribute("data-instant-clear-cart") === "true",
            d = n.closest("[data-instant-form-product-url]");
          if (!d) return null;
          let g = $(d),
            m = d.querySelector(`input[name="${g}__selling-plan-id"]`),
            E = d.querySelector(`input[name="${g}__selling-plan-name"]`),
            h = d.getAttribute("data-instant-form-selling-plan-id"),
            { sellingPlans: w } = nt(d, g);
          if (m?.value || E?.value)
            if (m?.value === "one-time-purchase") h = null;
            else {
              let y = w.find(
                (b) =>
                  (b.sellingPlanId === m?.value ||
                    b.sellingPlanName === decodeURIComponent(E?.value ?? "")) &&
                  b.variantId === i
              );
              y?.sellingPlanId && (h = y.sellingPlanId);
            }
          n.classList.add("instant-loading"),
            (n.style.cursor = "wait"),
            n.setAttribute("disabled", "disabled"),
            o &&
              (await fetch(`${window.Shopify?.routes?.root}cart/clear.js`, {
                method: "POST",
              }).catch((y) => {
                console.error("Failed to clear cart", y);
              })),
            l &&
              ((document.cookie = `discount_code=${l}; path=/`),
              await fetch(`${window.Shopify?.routes?.root}discount/${l}`).catch(
                (y) => {
                  console.error("Failed to set discount code", y);
                }
              )),
            fetch(`${window.Shopify?.routes?.root}cart/add.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [
                  {
                    id: i,
                    quantity: r,
                    ...(h !== "one-time-purchase" ? { selling_plan: h } : {}),
                  },
                ],
              }),
            })
              .then((y) => {
                if (!y.ok) throw new Error();
                switch (e) {
                  case "redirect-to-cart":
                    window.location.href = `${window.Shopify?.routes?.root}cart`;
                    break;
                  case "redirect-to-checkout":
                    window.location.href = `${window.Shopify?.routes?.root}checkout`;
                    break;
                  default:
                    let b = new CustomEvent("instant:add-to-cart", {
                      bubbles: !1,
                    });
                    document.dispatchEvent(b);
                }
              })
              .catch(() => {
                let y = document.createElement("form");
                y.setAttribute("method", "POST"),
                  y.setAttribute(
                    "action",
                    `${window.Shopify?.routes?.root}cart/add`
                  ),
                  y.setAttribute("novalidate", "novalidate"),
                  [
                    ["id", i ?? ""],
                    ["product-id", t ?? ""],
                    ["form_type", "product"],
                    ["quantity", r],
                    ["utf8", "\u2713"],
                  ].forEach(([b, M]) => {
                    let v = document.createElement("input");
                    v.setAttribute("type", "hidden"),
                      v.setAttribute("name", b),
                      v.setAttribute("value", M),
                      y.appendChild(v);
                  }),
                  document.body.appendChild(y),
                  y.submit();
              })
              .finally(() => {
                n.classList.remove("instant-loading"),
                  n.style.removeProperty("cursor"),
                  n.removeAttribute("disabled");
              });
          break;
        case "scroll-to-section":
          t && ut(t);
          break;
        case "quantity-increment":
        case "quantity-decrement":
          ft(n, e === "quantity-increment" ? "increment" : "decrement");
          break;
        case "select-variant-option":
          gt(n);
          break;
        case "select-selling-plan":
          yt(n);
          break;
        case "open-page":
          return !1;
        default:
          return console.warn(`Unknown instant action type: ${e}`), !1;
      }
      return !0;
    },
    At = (n) => {
      let e = n.querySelectorAll(
        'a[data-instant-action-type]:not([data-instant-action-type="open-page"]), button[data-instant-action-type], div[data-instant-action-type]'
      );
      Array.from(e).forEach((i) => {
        i.addEventListener("click", (s) => {
          s.preventDefault(), s.stopPropagation();
          let r = s.currentTarget;
          return !r || !(r instanceof HTMLElement) ? null : (Z(r), !1);
        });
      });
      let t = document.querySelectorAll(
        ".__instant div[href], .__instant form[href]"
      );
      Array.from(t).forEach((i) => {
        i.addEventListener("click", (s) => {
          let r = s.currentTarget;
          if (!r || !(r instanceof HTMLElement)) return null;
          let l = J(s.target);
          s.target instanceof HTMLLabelElement ||
            s.target instanceof HTMLInputElement ||
            s.target instanceof HTMLFieldSetElement ||
            s.target instanceof HTMLAnchorElement ||
            s.target instanceof HTMLButtonElement ||
            l instanceof HTMLAnchorElement ||
            l instanceof HTMLButtonElement ||
            l instanceof HTMLInputElement ||
            l instanceof HTMLLabelElement ||
            l instanceof HTMLFieldSetElement ||
            (s.preventDefault(),
            s.stopPropagation(),
            Z(r).then((o) => {
              if (o) return;
              let d = r.getAttribute("href"),
                g = r.getAttribute("target"),
                m = r.getAttribute("rel");
              d && window.open(d, g || "_self", m || void 0);
            }));
        });
      });
    },
    X = (n, e) => {
      let t = n.split("/").pop();
      e.setAttribute("name", `__tt_embed__${t}`),
        window.addEventListener("message", (i) => {
          try {
            let s = JSON.parse(i.data);
            s.height &&
              document
                .querySelector(`[name="${s.signalSource}"]`)
                ?.closest(".instant-video__container, .video__container")
                ?.setAttribute(
                  "style",
                  `height:${s.height}px;width:325px;border-radius:8px 8px 8px 8px;overflow:hidden`
                );
          } catch {}
        });
    },
    bt = (n) => {
      let e = n.querySelectorAll(
        "article.instant-video__wrapper, article.video__wrapper"
      );
      Array.from(e).forEach((t) => {
        t.addEventListener("click", () => {
          if (
            !t.querySelector("iframe") &&
            t.getAttribute("data-type") !== "external"
          ) {
            let i = t.getAttribute("data-src") ?? "",
              s = t.getAttribute("data-title") ?? "",
              r = document.createElement("iframe");
            (r.className = "instant-video__iframe"),
              r.setAttribute("src", i),
              r.setAttribute("title", s),
              r.setAttribute("frameborder", "0"),
              r.setAttribute(
                "allow",
                "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              ),
              r.setAttribute("allowfullscreen", "allowfullscreen"),
              t.style.setProperty("background-image", "none"),
              i?.includes("tiktok") && X(i, r),
              t.appendChild(r);
          } else if (
            !t.querySelector("video") &&
            t.getAttribute("data-type") === "external"
          ) {
            let i = t.getAttribute("data-src") ?? "",
              s = document.createElement("video");
            (s.className = "instant-video__player"),
              s.setAttribute("autoplay", "true"),
              s.setAttribute("controls", "true"),
              s.setAttribute("playsInline", "true"),
              s.setAttribute("src", i),
              t.style.setProperty("background-image", "none"),
              t.appendChild(s);
          }
        });
      });
    },
    tt = (n, e) => {
      let t = document.querySelector(`.i${n}`),
        i = document.querySelectorAll(`[data-instant-tab-id="${n}"]`);
      if (e) for (let s of e) s.setAttribute("data-instant-state", "closed");
      if ((t && t.setAttribute("data-instant-state", "open"), i))
        for (let s of i) {
          let l = s?.parentNode?.querySelectorAll(
            `:scope > [data-instant-type="tabs-trigger"]:not([data-instant-tab-id="${n}"])`
          );
          if (l)
            for (let o of l) o.setAttribute("data-instant-state", "inactive");
          s.setAttribute("data-instant-state", "active");
        }
    },
    et = (n, e) => {
      let t = document.querySelector(`.i${n}`);
      if (e) for (let i of e) i.style.setProperty("display", "none");
      t && t.style.removeProperty("display");
    },
    H = "instant-scroll-trigger--hidden";
  function ht(n, e, t) {
    n.forEach((i) => {
      let s = i.target;
      i.isIntersecting
        ? (s.classList.contains(H) && s.classList.remove(H),
          t || e.unobserve(s))
        : t && s.classList.add(H);
    });
  }
  let Et = (n) => {
      let e = n.querySelectorAll(".instant-scroll-trigger");
      e.length !== 0 &&
        e.forEach((t) => {
          let i =
              t.getAttribute("data-instant-scroll-into-view-replay") === "true",
            s = t.getAttribute("data-instant-scroll-into-view-offset")
              ? Number(t.getAttribute("data-instant-scroll-into-view-offset"))
              : 0;
          if (window.getComputedStyle(t).position === "fixed") {
            let l = !1,
              o = () => {
                if (window.scrollY < s) {
                  i && t.classList.add(H), (l = !1);
                  return;
                }
                t.classList.contains(H) && t.classList.remove(H), (l = !1);
              },
              d = () => {
                l || (window.requestAnimationFrame(o), (l = !0));
              };
            window.addEventListener("scroll", d);
          } else
            new IntersectionObserver((o, d) => ht(o, d, i), {
              root: document,
              threshold: 0,
              rootMargin: `${-s}px 0px`,
            }).observe(t);
        });
    },
    Tt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="tabs-container"]'),
        t = n?.querySelectorAll('[data-instant-type="tabs-trigger"]');
      Array.from(e).forEach((i) => {
        let l = i
          ?.querySelector('[data-instant-type="tabs-pane"]')
          ?.parentNode?.querySelectorAll(
            ':scope > [data-instant-type="tabs-pane"]'
          );
        l?.[0]?.id &&
          (et(l[0].id, l), window.requestAnimationFrame(() => tt(l[0].id, l)));
      }),
        Array.from(t).forEach((i) => {
          let s = i.getAttribute("data-instant-tabs-id"),
            r = i.getAttribute("data-instant-tab-id");
          if (s && r) {
            let g = document
              .querySelector(`.i${s}`)
              ?.querySelector('[data-instant-type="tabs-pane"]')
              ?.parentNode?.querySelectorAll(
                ':scope > [data-instant-type="tabs-pane"]'
              );
            t &&
              g &&
              i.addEventListener("click", () => {
                let m = i.getAttribute("data-instant-tab-id") || "";
                et(m, g), window.requestAnimationFrame(() => tt(m, g));
              });
          }
        });
    },
    vt = (n) => {
      let e = n.querySelectorAll('[data-instant-type="ticker"]');
      Array.from(e)
        .reverse()
        .forEach((t) => {
          let i = t.querySelector(".instant-ticker-initial-child-container"),
            s = i?.closest(".instant-ticker"),
            r = s?.nextElementSibling,
            l = [s, r],
            o = t.getAttribute("data-instant-ticker-is-reversed") === "true",
            d = +(t.getAttribute("data-instant-ticker-speed") || 50),
            g = t.getAttribute("data-instant-ticker-pause") === "true" || !1;
          if (t && i) {
            let m = i.children,
              E = 1,
              h = 0,
              w = () => {
                let b = t.getBoundingClientRect(),
                  M = i.getBoundingClientRect();
                if (b && M) {
                  let v = Math.min(b.width, 9999),
                    p = M.width,
                    I = window.getComputedStyle(i),
                    P = I.columnGap.includes("px") ? I.columnGap : "0px";
                  t.style.setProperty("--gap", P),
                    (E = p && v && p < v ? Math.ceil(v / p) : 1),
                    (h = (p * E) / d);
                }
                t.style.getPropertyValue("--multiplier") !== `${E}` &&
                  (s && s.replaceChildren(i),
                  r && (r.innerHTML = ""),
                  Array.from(l).forEach((v, p) => {
                    v &&
                      [...Array(Math.max(0, p === 0 ? E - 1 : E))].forEach(
                        () => {
                          Array.from(m).forEach((I) => {
                            let P = I.cloneNode(!0);
                            v.appendChild(P);
                          });
                        }
                      );
                  })),
                  t.style.setProperty("--play", "running"),
                  t.style.setProperty("--direction", o ? "reverse" : "normal"),
                  t.style.setProperty("--duration", `${h}s`),
                  t.style.setProperty(
                    "--pause-on-hover",
                    g ? "paused" : "running"
                  ),
                  t.style.setProperty("--multiplier", `${E}`),
                  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
                    t.querySelectorAll('img[loading="lazy"]').forEach((p) => {
                      p.loading = "eager";
                    });
              };
            w();
            let y = new ResizeObserver(w);
            y.observe(t), y.observe(i);
          }
        });
    },
    Lt = (n) => {
      let e = n.querySelectorAll("iframe.tiktok__autoplay");
      Array.from(e).forEach((t) => {
        let i = t.getAttribute("src") ?? "";
        X(i, t);
      });
    },
    It = (n) => {
      let e = n.querySelectorAll(
        ".instant-video-fill__controls, .video-fill__controls"
      );
      Array.from(e).forEach((t) => {
        let i = t.closest(".instant-video-fill__wrapper, .video-fill__wrapper"),
          s = i?.querySelector("video");
        i &&
          s &&
          t.addEventListener("click", () => {
            s.paused
              ? (s.play(), i.setAttribute("data-paused", "false"))
              : (s.pause(), i.setAttribute("data-paused", "true"));
          });
      });
    },
    nt = (n, e) => {
      let t = n.querySelectorAll('[type="application/json"]'),
        i,
        s,
        r;
      return (
        Array.from(t).forEach((l) => {
          l.id.startsWith(`variants__${e}--`) && (i = JSON.parse(l.innerHTML)),
            l.id.startsWith(`options__${e}--`) && (s = JSON.parse(l.innerHTML)),
            l.id.startsWith(`selling_plans__${e}--`) &&
              (r = JSON.parse(l.innerHTML));
        }),
        { variants: i, options: s, sellingPlans: r }
      );
    },
    St = (n, e) => (e ? n?.find((t) => t.id === Number(x(e))) : n?.[0]),
    wt = (n) => {
      let e = n.querySelectorAll(
        ".__instant form[data-instant-form-product-url]"
      );
      Array.from(e).forEach((t) => {
        let i = t.closest(".__instant")?.getAttribute("data-section-id"),
          s = t.querySelectorAll(
            'input[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
          );
        Array.from(s).forEach((r) => {
          r.addEventListener("blur", (l) => {
            let o = r.getAttribute("min") ?? "1",
              d = r.getAttribute("max") ?? "999",
              g = parseInt(r.value, 10);
            l.target instanceof HTMLInputElement &&
              (g = parseInt(l.target.value, 10)),
              o && g < parseInt(o, 10) && (r.value = o),
              d && g > parseInt(d, 10) && (r.value = d),
              isNaN(g) && (r.value = o),
              r.dispatchEvent(new Event("change", { bubbles: !0 }));
          });
        }),
          t.addEventListener("change", (r) => {
            let l = new FormData(r?.currentTarget),
              o = r.target?.closest("[data-instant-form-product-url]");
            if (!o) {
              console.warn("No scope found for form change event");
              return;
            }
            let d = $(o);
            if (r.target?.name === "quantity") {
              let a = parseInt(r.target?.value, 10);
              isNaN(a) && (a = 1);
              let u = o.querySelectorAll(
                'input[data-instant-dynamic-content-source="QUANTITY_SELECT"]'
              );
              for (let S of u) S.value = a.toString();
              let f = [
                  "add-to-cart",
                  "redirect-to-cart",
                  "redirect-to-checkout",
                ]
                  .map((S) => `[data-instant-action-type="${S}"]`)
                  .join(", "),
                L = o.querySelectorAll(f);
              for (let S of L) S.href = K(S.href, a.toString());
              return;
            }
            let g = o?.getAttribute("data-instant-form-variant-id"),
              m = o?.getAttribute("data-instant-form-product-url"),
              E = o?.getAttribute("data-instant-form-selling-plan-id"),
              { variants: h, options: w, sellingPlans: y } = nt(o, d),
              b = St(h, g),
              M = [];
            for (let [a, u] of l)
              a.startsWith(d) &&
                M.push({
                  key: decodeURIComponent(a.replace(`${d}__`, "")),
                  value: String(u),
                });
            let v = [b?.option1, b?.option2, b?.option3],
              p = [];
            if (w)
              for (let a of w)
                p.push(
                  M.find(({ key: u }) => u === a.name)?.value ??
                    v[a.position - 1]
                );
            let I = h
                ? h?.find(({ option1: a, option2: u, option3: c }) => {
                    let f = [a, u, c].filter(Boolean),
                      L = p.filter(Boolean);
                    return f.every((S, Pt) => S === L[Pt]);
                  })?.id
                : g,
              P = document.querySelector(`input[name="${d}__selling-plan-id"]`),
              k = document.querySelector(
                `input[name="${d}__selling-plan-name"]`
              ),
              _ = x(P?.value),
              A = x(k?.value),
              q = y?.find(
                (a) =>
                  a.variantId === I.toString() &&
                  (a.sellingPlanId === _?.toString() ||
                    a.sellingPlanName ===
                      decodeURIComponent(A?.toString() ?? ""))
              );
            !q &&
              _ !== "one-time-purchase" &&
              (q = y?.find(
                (a) => a.variantId === I.toString() && a.sellingPlanId === E
              ));
            let at = o.querySelectorAll(
                '[data-instant-dynamic-content-source="PRICE"]'
              ),
              V = ["COMPARE_AT", "SAVED_AMOUNT", "SAVED_PERCENTAGE"]
                .map((a) => `[data-instant-dynamic-content-source="${a}"]`)
                .join(", "),
              B = o.querySelectorAll(V),
              D = o.querySelectorAll(
                'fieldset[data-instant-type="VARIANT_PICKER"] select option'
              ),
              F = o.querySelectorAll(
                'fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]'
              ),
              st = o.querySelectorAll(
                'img[data-instant-dynamic-content-source="FEATURED_IMAGE"]'
              ),
              z = o.querySelectorAll(
                'img[data-instant-dynamic-content-source="REPEATER"]'
              ),
              U = ["add-to-cart", "redirect-to-cart", "redirect-to-checkout"]
                .map((a) => `[data-instant-action-type="${a}"]`)
                .join(", "),
              Q = o.querySelectorAll(U),
              j = '[data-instant-action-type="open-page"]',
              W = o.querySelectorAll(j),
              C = o.querySelectorAll(
                '[data-instant-action-type="select-variant-option"]'
              ),
              O = o.querySelectorAll(
                '[data-instant-action-type="select-selling-plan"]'
              ),
              N = o.querySelectorAll("[data-instant-conditional]");
            dt({
              dataset: { url: m, sectionId: i },
              variantId: I,
              scope: o,
              scopeId: d,
              priceElements: at,
              comparativePriceElements: B,
              variantSelectOptions: D,
              variantRadios: F,
              featuredVariantImages: st,
              repeaterImages: z,
              addToCartButtons: Q,
              viewProductButtons: W,
              quantity: l.get("quantity") ?? 1,
              customVariantSelects: C,
              sellingPlanElements: O,
              selectedSellingPlan: q,
              conditionals: N,
            });
          });
      }),
        Array.from(e).forEach((t) => {
          t.dispatchEvent(new Event("change"));
        });
    },
    R = (n) => {
      window.Instant.initializedListeners = !0;
      let e = document;
      if (n)
        if (n instanceof Element) e = n;
        else {
          let t = document.getElementById(n);
          t && (e = t);
        }
      pt(e),
        At(e),
        mt(e),
        bt(e),
        Et(e),
        Tt(e),
        vt(e),
        Lt(e),
        window.__instantInitSliders?.(e),
        It(e),
        wt(e);
    },
    // Mt = () => {
    //   window.Shopify?.shop &&
    //     document.querySelector(".__instant") &&
    //     fetch(
    //       `https://static-api.instant.so/public/site/${window.Shopify.shop}`
    //     )
    //       .then((n) => n.json())
    //       .then((n) => {
    //         if (n?.showBadge) {
    //           let e = () =>
    //               new DOMParser().parseFromString(n.showBadge, "text/html").body
    //                 .firstChild,
    //             t = document.body.appendChild(e()),
    //             i = new MutationObserver((s) => {
    //               s.forEach((r) => {
    //                 if (
    //                   (r.type === "childList" &&
    //                     [...r.removedNodes].includes(t)) ||
    //                   r.type === "attributes"
    //                 ) {
    //                   i.disconnect(), t && t.parentNode && t.remove();
    //                   let l = e();
    //                   (t = document.body.appendChild(l)),
    //                     i.observe(t, { attributes: !0 }),
    //                     i.observe(document.body, { childList: !0 });
    //                 }
    //               });
    //             });
    //           i.observe(t, { attributes: !0 }),
    //             i.observe(document.body, { childList: !0 });
    //         }
    //       });
    // },
    it = () => {
      R(),
        Mt(),
        window?.Shopify?.designMode &&
          document.addEventListener("shopify:section:load", (n) => {
            let e = `shopify-section-${n.detail.sectionId}`;
            e && R(e);
          });
    };
  document.readyState !== "loading"
    ? it()
    : document.addEventListener("DOMContentLoaded", () => {
        it();
      });
})();
